export default __webpack_public_path__ + "images/a3d7210c51ff07920ab78bbc7888d855-holiday_tablet.webp";